import { BRAND_REDIRECT_LINK } from 'constants/links';
import { findFontsInPage } from 'modules/Editor/store/infographSlice.helpers';
import { BrandState } from 'modules/User/brand.types';
import { PageId } from 'types/idTypes';
import { InfographState } from 'types/infographTypes';

export const getAllFontsInfograph = (infograph: InfographState) => {
  const pages = infograph?.pageOrder;
  if (!pages || !pages.length) return [];

  let fonts: string[] = [];
  pages.forEach((pageId: PageId) => {
    const pageFonts = findFontsInPage(infograph, pageId);
    fonts = [...fonts, ...pageFonts];
  });

  // remove duplicate fonts
  return [...new Set(fonts)];
};

/**
 * Returns an array of (unique) fonts used for the brand
 * @param brand - BrandState
 * @returns string[] - array of fonts
 * @example getBrandFonts({ title: 'Roboto', subtitle: 'Roboto', text: 'Inter' }) => ['Roboto', 'Inter']
 */
export const getBrandFonts = (brand: BrandState | undefined) => {
  const brandFonts: string[] = [];
  if (!brand) return brandFonts;

  if (brand?.title) brandFonts.push(brand.title.fontFamily);
  if (brand?.subtitle) brandFonts.push(brand.subtitle.fontFamily);
  if (brand?.text) brandFonts.push(brand.text.fontFamily);

  // only return unique fonts
  return [...new Set(brandFonts)];
};

// Redirects to the brand page
export const redirectToBrandPage = () => window.open(BRAND_REDIRECT_LINK, '_blank');
